import { Skeleton } from "antd";
import { useEffect, useState } from "react";

import { usePartnership } from "@app/pages/partnership/model/partnership-provider";
import { Loc, Price } from "@app/shared/ui";

type MaxAvailableAmountProps = {
  title?: React.ReactNode;
  onReady: (amount: number) => void;
  onClick: () => void;
};
const MaxAvailableAmount: React.FC<MaxAvailableAmountProps> = ({
  onReady,
  onClick,
  title,
}) => {
  const { loading, fetchMaxAvailableAmount } = usePartnership();
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    (async () => {
      const result = await fetchMaxAvailableAmount();
      if (!result.success) return;
      setAmount(result.body ?? 0);
      onReady(result.body ?? 0);
    })();
  }, [fetchMaxAvailableAmount, onReady]);

  if (loading.fetchingMaxAvailableAmount) {
    return <Skeleton.Input size="small" active className="mt-2 mb-5" />;
  }

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a onClick={onClick}>
      {title ?? (
        <Loc
          word="Partnership.transaction.maxAvailableAmount"
          default="Max available amount"
        />
      )}
      :&nbsp;
      <Price price={amount} truncateIfFractionalZero className="fw-500" />
    </a>
  );
};

export default MaxAvailableAmount;
